module.exports = __webpack_public_path__ + "img/cambodia.cf6c55b9.svg";